import api from "./api";
import { DocumentToUploadType } from "../types";

export async function updateDocument(
    documentId: number | null,
    data: any
): Promise<any | null> {
    return await api
        .patch("api/document/" + documentId, data)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function uploadDocument(
    docInfosToUpload: DocumentToUploadType
): Promise<any | null> {
    return await api
        .post("api/documents/upload/", docInfosToUpload, {
            headers: {
                "Content-Type":
                    "multipart/form-data; boundary=<calculated when request is sent>",
            },
        })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function downloadDocument(
    documentId: number
): Promise<any | null> {
    return await api
        .get("api/documents/download/" + documentId, { responseType: "blob" })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function deleteDocument(
    documentId: number | null
): Promise<any | null> {
    return await api
        .delete("api/document/" + documentId)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function downloadCertficate(
    dossierId: number
): Promise<any | null> {
    return await api
        .get("api/telecharger-certificat/" + dossierId, {
            responseType: "blob",
        })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function downloadContract(dossierId: number): Promise<any | null> {
    return await api
        .get("api/telecharger-contrat/" + dossierId, { responseType: "blob" })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}

export async function exportCsvService(userRoleId?: number | null, establishmentGroup?: number | null, region?: number | null): Promise<any | null> {
    let url = "api/establishments/csv/";
    url = `${url}?role_id=${userRoleId}`;
    if (establishmentGroup){
        url = `${url}&establishment_group_id=${establishmentGroup}`
    }
    if (region) {
        url = `${url}&region_id=${region}`
    }
    return await api
        .get(url, { responseType: "blob" })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);
            if (error.response) {
                return error.response;
            }
            return error;
        });
}
